<template>
  <div class="page_container warehousingRecordPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/outboundIndex/outboundList' }"
          >出库管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/outboundIndex/outboundDetail' }"
          >订单详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>配货管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between" v-if="false">
        <div class="select_add flex-rowl" @click="handleDetail(0)">
          <p class="flex-rowl"><i class="iconfont icon-xinzeng"></i> 新增</p>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl" @click="handleDetail(item.id)">
                  <div class="block">
                    <p>
                      物流ID：<span>{{ item.wsid }}</span>
                    </p>
                    <p>
                      订单ID：<span>{{
                        item.orderid ? item.orderid : ""
                      }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>商品内容：</p>
                    <div class="shop_con">
                      <p>
                        <span>商品名称：{{ item.cmname }}</span>
                      </p>
                      <!-- <p>
                        <span>商品ID：{{ item.cmid }}</span>
                      </p> -->
                      <p>
                        <span>SKU：{{ item.sku }}</span>
                      </p>
                      <p><span>{{item.attr}}</span></p>
                      <!-- <div
                        v-for="(label, labelIndex) in item.attr"
                        :key="labelIndex"
                      >
                        <p>
                          <span>{{ label | formatAttr }}</span>
                        </p>
                      </div> -->
                      <p>
                        <span>商品所属企业：{{ item.qyguidstr }}</span>
                      </p>
                      <p>
                        <span> 配货所需数量：{{ item.cmnum }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="block">
                    <p class="flex-rowl">
                      <span>库源信息：</span><span v-html="item.msg"></span>
                    </p>
                    <p>
                      操作时间：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                    <p>
                      商品类型：<span>{{ item.ismain ? '主商品' : '配件'}}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="detail_icon" @click="handleDetail(item.id)">
                  <i class="iconfont icon-details"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无入库记录"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { encryptstringview,encryptstringadd } from "../../api/api";
import { getLogisticsDisList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundDistributionList",
  data() {
    return {
      qyguid: "",
      keyword: "",
      listTotal: 0,
      params: {
        wsid: "",
        pageindex: 1,
        pagesize: 20,
      },
      loading: false,
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    formatAttr(date) {
      if (date.indexOf("；") != -1) {
        let splitArr = date.split("；");
        let str1 = "属性标签：" + splitArr[0];
        let str2 = "属性标签值：" + splitArr[1];
        return str1 + "；" + str2;
      } else {
        let str = "属性标签：" + date;
        return str;
      }
      // let splitArr = date.indexOf('；') != -1 ? date.split('；') : date
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyguid = USERINFO.qy ? USERINFO.qy.qyguid : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { wsid } = JSON.parse(res.jsondata);
        this.params.wsid = wsid;
        this.getLogisticsDisList();
      } else {
        this.$router.back();
      }
    },

    handleCurrentChange(e) {
      this.params.Page = e;
      // this.dataList = [];
      this.getLogisticsDisList();
    },
    handleSearch() {
      this.params.Page = 1;
      this.getLogisticsDisList();
    },

    getLogisticsDisList() {
      let { params } = this;
      this.loading = true;
      getLogisticsDisList(params).then((res) => {
        res.list.forEach((v) => {
          v.msg = v.msg != "" ? v.msg.replace(/\|/g, "<br/>") : "";
          v.attr = v.attr != "" ? JSON.parse(v.attr) : "";
        });
        this.dataList = res.list;
        this.listTotal = res.total;
        // 加载状态结束
        this.loading = false;
      });
    },

    // 物流详情
    handleDetail(id) {
      // this.$router.push(
      //   `/outboundIndex/outboundDistribution/${id}/${this.params.wsid}`
      // );
      this.encryptstringadd('outboundDistribution', {id, wsid: this.params.wsid})
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .main_container {
    margin-top: 25px;
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .list_wrap {
      height: 61vh;
      .block {
        align-items: flex-start;
        p {
          align-items: flex-start;
        }
      }
    }
    .red {
      color: #ee0032;
    }
  }
  .intro_box {
    cursor: pointer;
  }
}
</style>